var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logging"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('LoggingTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }